import { useUniqueInlineId } from '@inline-svg-unique-id/react'
import React from 'react'
import { SVGIconProps } from '../types'
const SvgBayClass = function ({ size = 16, ...props }: SVGIconProps) {
  const _id = useUniqueInlineId()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size}
      height={size}
      viewBox="0 0 200 48"
      fill="currentColor"
      {...props}
    >
      <defs>
        <path
          id={_id}
          d="M195.757 47.315 200 36.74l-.23-4.247h-72.56l.077-8.18h-1.234v.463l.616.077-.074 7.64-12.814.079-.079-4.091h-.54l-.155 4.091-2.394-.154-.075-10.19.768.076.157.466.386-.156.078-.929h-.54v-.46l-.928.076.079-1.002-.619-.077-5.403.385-.234-.542-11.886-.075-1.156.232-1.006-.541-10.881.464-1.08.925.308.155-.077 4.013h.773l-.08-4.088 12.66.846v3.166h.617l-.078-3.242 1.546.309-.08 2.467.928 1.005-.307 6.792 2.623-.075-.08-10.345.543.08.076.384h.542l.157-.852 6.558.544 3.395.155.155 3.629-.462 6.559H76.344v-1.004h-1.08l.154-.385h.926v-.771l-1.159-.232v-.54h1.39l.156-.233-1.546-.076-.077-2.86 1.236-.23.077-.309-1.466-.076.077-3.167 1.236-.075-.08-.31h-1.465l-.079-3.01 1.39-.153-1.465-.232V15.98l.229-.387-1.774-.077-.388-3.63-7.178-.151-.074-2.936-1.238-6.094h-1.001l-2.162 6.018-1.237.076-.078 1.236-2.466.08-.08 1.62-13.662.076L43.538 0h-.541l-1.931 9.571h-7.797l.85 3.241-.615.077v.387h.463l-1.39 14.665s.385.615-.155.85c-.54.23-.618-1.236-.618-1.236l.388.078.074-.772-2.238-.154v.848l.233-.078v1.855l-11.04-.31.08 3.551s-.311.463-.85 0c-.539-.465-1.003-1.237-1.003-1.237L0 31.261l9.418 15.746z"
        />
      </defs>
      <use xlinkHref={`#${_id}`} fill="#3E5667" fillRule="evenodd" />
    </svg>
  )
}
export default SvgBayClass
